import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English translations
const commonEN = require('./locales/en/common.json');
const navigationEN = require('./locales/en/navigation.json');
const dashboardEN = require('./locales/en/dashboard.json');
const productsEN = require('./locales/en/products.json');
const ordersEN = require('./locales/en/orders.json');
const bidsEN = require('./locales/en/bids.json');
const conversationsEN = require('./locales/en/conversations.json');
const earningsEN = require('./locales/en/earnings.json');
const paymentsEN = require('./locales/en/payments.json');
const statsEN = require('./locales/en/stats.json');
const loginEN = require('./locales/en/login.json');
const authEN = require('./locales/en/auth.json');
const profileEN = require('./locales/en/profile.json');
const addProductEN = require('./locales/en/addProduct.json');
const validationEN = require('./locales/en/validation.json');

// French translations
const commonFR = require('./locales/fr/common.json');
const navigationFR = require('./locales/fr/navigation.json');
const dashboardFR = require('./locales/fr/dashboard.json');
const productsFR = require('./locales/fr/products.json');
const ordersFR = require('./locales/fr/orders.json');
const bidsFR = require('./locales/fr/bids.json');
const conversationsFR = require('./locales/fr/conversations.json');
const earningsFR = require('./locales/fr/earnings.json');
const paymentsFR = require('./locales/fr/payments.json');
const statsFR = require('./locales/fr/stats.json');
const loginFR = require('./locales/fr/login.json');
const authFR = require('./locales/fr/auth.json');
const profileFR = require('./locales/fr/profile.json');
const addProductFR = require('./locales/fr/addProduct.json');
const validationFR = require('./locales/fr/validation.json');

const resources = {
  en: {
    common: commonEN,
    navigation: navigationEN,
    dashboard: dashboardEN,
    products: productsEN,
    orders: ordersEN,
    bids: bidsEN,
    conversations: conversationsEN,
    earnings: earningsEN,
    payments: paymentsEN,
    stats: statsEN,
    login: loginEN,
    auth: authEN,
    profile: profileEN,
    addProduct: addProductEN,
    validation: validationEN,
  },
  fr: {
    common: commonFR,
    navigation: navigationFR,
    dashboard: dashboardFR,
    products: productsFR,
    orders: ordersFR,
    bids: bidsFR,
    conversations: conversationsFR,
    earnings: earningsFR,
    payments: paymentsFR,
    stats: statsFR,
    login: loginFR,
    auth: authFR,
    profile: profileFR,
    addProduct: addProductFR,
    validation: validationFR,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr', // Default language is French
    fallbackLng: 'fr', // Fallback to French if translation missing
    defaultNS: 'common',
    ns: [
      'common',
      'navigation',
      'dashboard',
      'products',
      'orders',
      'bids',
      'conversations',
      'earnings',
      'payments',
      'stats',
      'login',
      'auth',
      'profile',
      'addProduct',
      'validation',
    ],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'], // Only check localStorage, don't use navigator
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      // Don't use navigator language - always default to French
    },
  });

export default i18n;

